import { directionColumn } from 'styles/mixins';

export default () => ({
  container: {
    ...directionColumn,
  },
});
